export default [
  {
    path: '/fish-types',
    name: 'fish-types',
    component: () => import('@/views/pages/record-catch/fish-type/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.fish-types',
      resource: 'record_catch',
      action: 'list',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          active: true,
        },
      ],
    },
  },
  {
    path: '/fish-types/add',
    name: 'add-fish-type',
    component: () => import('@/views/pages/record-catch/fish-type/Add.vue'),
    meta: {
      pageTitle: 'breadcrumb.fish-types',
      resource: 'record_catch',
      action: 'create',
      breadcrumb: [
        {
          text: 'breadcrumb.add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/fish-types/modify/:id',
    name: 'modify-fish-type',
    component: () => import('@/views/pages/record-catch/fish-type/Modify.vue'),
    meta: {
      pageTitle: 'breadcrumb.fish-types',
      resource: 'record_catch',
      action: 'edit',
      breadcrumb: [
        {
          text: 'breadcrumb.modify',
          active: true,
        },
      ],
    },
  },
]
